"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationStatusRoutes = void 0;
var ApplicationStatusRoutes;
(function (ApplicationStatusRoutes) {
    ApplicationStatusRoutes["BasePrefix"] = "application-statuses";
    ApplicationStatusRoutes["ById"] = ":applicationStatusId";
    ApplicationStatusRoutes["All"] = "all";
    ApplicationStatusRoutes["List"] = "list";
})(ApplicationStatusRoutes = exports.ApplicationStatusRoutes || (exports.ApplicationStatusRoutes = {}));
